import appSelectors, { getShouldShowPayLaterPostPurchaseMenuItem } from 'App/duck/selectors'

import { MENU_ITEM_KEYS } from '../constants'
import { fetchReviewItemsNumber, fetchUserMenu } from '../requests'
import actions from './actions'
import { normalizeReviewItemsNumber, normalizeUserMenuWithSubtext } from './normalize'
import selectors from './selectors'

export const operationSetBadges =
  (shouldShowCompleteProfileReminder = false) =>
  (dispatch, getState) => {
    const state = getState()

    const isEmailConfirmationStateUnconfirmed =
      appSelectors.getIsEmailConfirmationStateUnconfirmed(state)
    const hasSettingsBadge = selectors.getHasBadge(state, MENU_ITEM_KEYS.mySettings)

    const shouldShowBadgeOnSettings =
      !hasSettingsBadge &&
      (isEmailConfirmationStateUnconfirmed || shouldShowCompleteProfileReminder)

    if (shouldShowBadgeOnSettings) {
      dispatch(actions.setBadge(MENU_ITEM_KEYS.mySettings))
    }
  }

export const operationSetMenuItemBadges =
  (shouldShowCompleteProfileReminder = false, shouldShowActiveOrdersBadge = false) =>
  (dispatch, getState) => {
    const state = getState()

    const isEmailConfirmationStateUnconfirmed =
      appSelectors.getIsEmailConfirmationStateUnconfirmed(state)
    const hasSettingsBadge = selectors.getHasBadge(state, MENU_ITEM_KEYS.mySettings)

    const shouldShowBadgeOnSettings =
      !hasSettingsBadge &&
      (isEmailConfirmationStateUnconfirmed || shouldShowCompleteProfileReminder)

    const menuItemsBadge = {
      mysettings: shouldShowBadgeOnSettings,
      purchases: shouldShowActiveOrdersBadge,
    }
    const userMenus = selectors.getNewUserMenus(state)
    const updatedUserMenu = [...userMenus].map((item) => {
      if (menuItemsBadge[item.key] !== undefined) {
        item.shouldShowBadge = menuItemsBadge[item.key]
      }
      return item
    })
    dispatch(actions.updateUserMenuState(updatedUserMenu))
  }

export const operationSetDisablement = () => (dispatch, getState) => {
  const state = getState()

  const menuItems = [
    {
      key: MENU_ITEM_KEYS.reviewItems,
      shouldBeDisabled: selectors.getShouldDisableReviewItems(state),
    },
  ]

  menuItems.forEach((menuItem) => {
    const shouldChange = selectors.getIsDisabled(state, menuItem.key) !== menuItem.shouldBeDisabled
    if (shouldChange) {
      dispatch(actions.setDisablement(MENU_ITEM_KEYS.reviewItems, menuItem.shouldBeDisabled))
    }
  })
}

export const operationSetVisibility =
  ({ paymentFeatureFlag }) =>
  (dispatch, getState) => {
    const state = getState()

    const menuItems = [
      {
        key: MENU_ITEM_KEYS.reviewItems,
        shouldBeVisible: selectors.getShouldShowReviewItems(state),
      },
      {
        key: MENU_ITEM_KEYS.hmxklarna,
        shouldBeVisible: getShouldShowPayLaterPostPurchaseMenuItem(state),
      },
      {
        key: MENU_ITEM_KEYS.hmxklarnaActivation,
        shouldBeVisible: selectors.getShouldShowPayLaterActivationMenuItem(state),
      },
      {
        key: MENU_ITEM_KEYS.clubInfoPage,
        shouldBeVisible: selectors.getShouldShowClubInfoPage(state),
      },
      {
        key: MENU_ITEM_KEYS.pointsHistoryPage,
        shouldBeVisible: selectors.getShouldShowPointsHistoryPage(state),
      },
      {
        key: MENU_ITEM_KEYS.paymentCredits,
        shouldBeVisible: !paymentFeatureFlag || !selectors.getShouldShowPayments(state),
      },
    ]

    menuItems.forEach((menuItem) => {
      const shouldChange = selectors.getIsVisible(state, menuItem.key) !== menuItem.shouldBeVisible

      if (shouldChange) {
        dispatch(actions.setVisibility(menuItem.key, menuItem.shouldBeVisible))
      }
    })
  }

export const operationSetMenuItemsVisibility =
  ({ paymentFeatureFlag, shouldHelpUsEnable }) =>
  (dispatch, getState) => {
    const state = getState()
    const menuItemsVisible = {
      review: selectors.getShouldShowReviewItems(state),
      klarna: getShouldShowPayLaterPostPurchaseMenuItem(state),
      info: selectors.getShouldShowClubInfoPage(state),
      pointshistory: selectors.getShouldShowPointsHistoryPage(state),
      payment: !paymentFeatureFlag || !selectors.getShouldShowPayments(state),

      inviteafriend:
        appSelectors.getIsInviteFriendEnabled(state) && appSelectors.getUserIsFullMember(state),

      helpus: shouldHelpUsEnable,
    }

    const userMenus = selectors.getNewUserMenus(state)
    const updatedUserMenu = [...userMenus].map((item) => {
      if (menuItemsVisible[item.key] !== undefined) {
        item.isVisible = menuItemsVisible[item.key]
      }
      return item
    })
    dispatch(actions.updateUserMenuState(updatedUserMenu))
  }

export const operationSetNewMenuDisablement = () => (dispatch, getState) => {
  const state = getState()
  const userMenus = selectors.getNewUserMenus(state)

  const menuItemsDisable = {
    review: selectors.getShouldDisableReviewItems(state),
  }

  const updatedUserMenu = [...userMenus].map((item) => {
    if (menuItemsDisable[item.key] !== undefined) {
      item.isDisabled = menuItemsDisable[item.key]
    }
    return item
  })

  dispatch(actions.updateUserMenuState(updatedUserMenu))
}

export const operationFetchReviewItemsNumber = (isRateReviewEnabled) => (dispatch, getState) => {
  const userId = appSelectors.getUserBpid(getState())

  dispatch(actions.fetchReviewItemsNumberStart())

  fetchReviewItemsNumber(userId, isRateReviewEnabled)
    .then((res) => {
      const normalizedReviewItemsNumber = normalizeReviewItemsNumber(res)
      dispatch(actions.fetchReviewItemsNumberSuccess(normalizedReviewItemsNumber))
    })
    .catch((error) => dispatch(actions.fetchReviewItemsNumberFail(error)))
}

export const operationFetchUserMenu =
  (isAbTestEnabled = false) =>
  async (dispatch, getState) => {
    dispatch(actions.fetchUserMenuStart())
    try {
      const state = getState()
      const menuResponse = await fetchUserMenu()
      const userMenus = selectors.getNewUserMenus(state)
      const normalizedUserMenuWithSubtext = normalizeUserMenuWithSubtext(
        isAbTestEnabled ? menuResponse.item1.val : menuResponse.item0.val,
        userMenus,
        isAbTestEnabled,
      )
      dispatch(actions.fetchUserMenuSuccess(normalizedUserMenuWithSubtext))
    } catch (error) {
      dispatch(actions.fetchUserMenuFail())
    }
  }
